exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-icon--size-xxs{font-size:10px}.k-icon--size-xs{font-size:14px}.k-icon--size-s{font-size:18px}.k-icon--size-m{font-size:20px}.k-icon--size-l{font-size:22px}.k-icon--size-xl{font-size:28px}", ""]);

// exports
